import { Component, HostListener, ElementRef, ViewChild, OnDestroy, Optional, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { PortalComponentConstants } from '../utils/portal-component.constants';
import { PershingTranslationService, IAuthorizationService } from '@pershing/pershing-core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ada-page-content',
    templateUrl: 'ada-page-content.component.html'
})

export class PageContentComponent implements OnDestroy {
    lastIndex: string;
    description: string;
    title: string;
    queryParam: string;
    displayPageContents: boolean = true;
    timeOutSub: any;
    isDestroyed: boolean = false;
    ibdConfigMap: any;
    backToPage: string = 'Back to Page Contents';
    @ViewChild('adaPageContentLink') adaLink: ElementRef;

    constructor(
        private location: Location, private translationService: PershingTranslationService,
        private route: ActivatedRoute, private authService: IAuthorizationService,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-common', 'node_modules/@pershing/nxi-common/lib');
        this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');
        this.ibdConfigMap = appSettings.ibdConfigMap;
        this.translationService.get('NXI_PORTAL_COMPONENTS.BACK').subscribe( res => {
            this.backToPage = res;
        });
        this.timeOutSub = setTimeout(() => { this.populatePageContent(); }, 1000);
    }

    ngOnDestroy() {
        this.isDestroyed = true;
        if (this.timeOutSub) {
            clearTimeout(this.timeOutSub);
        }
    }

    getPageName() {
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (urlArray[urlArray.length - 1].split('?').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('?')[0];
        }
        if (urlArray[urlArray.length - 1].split('#').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('#')[0];
        }
        if (urlArray[urlArray.length - 1].split(';').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split(';')[0];
        }
        return urlArray[urlArray.length - 1];
    }

    populatePageContent() {
        if (this.isDestroyed) {
            return;
        }
        document.querySelector('[page-link]').innerHTML = '';
        let query: any = this.route.snapshot.queryParams;
        query = JSON.parse(JSON.stringify(query));
        let url = this.location.path(false);
        this.lastIndex = this.getPageName();
        this.queryParam = query.viewId;
        this.title = 'NXI_ADA_PORTAL.' + this.lastIndex + '.PAGE_TITLE';
        this.description = 'NXI_ADA_PORTAL.' + this.lastIndex + '.PAGE_DESC';
        if (PortalComponentConstants.AdaPageContentIgnoreList.indexOf(this.lastIndex) < 0) {
            setTimeout(() => { this.createPageContent(url); }, 1000);
        } else {
            this.displayPageContents = false;
        }
    }

    @HostListener('document:pershing.assembly.content.placed', ['$event'])
    componentPlacementEventHandle(event: any) {
        console.log(' In componentPlacementEventHandle event');
        if (this.timeOutSub) {
            clearTimeout(this.timeOutSub);
        }
        this.timeOutSub = setTimeout(() => { this.populatePageContent(); }, 1000);
    }

    createPageContent(url) {
        if (this.isDestroyed) {
            return;
        }
        const cols = document.querySelectorAll('[component-id]');
        [].forEach.call(cols, (element) => {
            let linkName: string = element.getAttribute('component-id');
            // to work with latest changes to page-assembly-core
            // Old Markup
            // <div component-id="balances-summary"><balances-summary></balances-summary></div>
            // New Markup
            // <pershing-component component-id="balances-summary">
            // <div>..
            // <div>..
            // <balances-summary></balances-summary>
            // </div>
            // </div>
            // </pershing-component>
            element = element.getElementsByTagName(linkName)[0];
            if (linkName === 'nxi-f2-component' && element && element.childNodes.length > 2) {
                linkName = element.getElementsByTagName('f2-component')[0].id;
                console.log('  F2 component ', linkName);
                if (linkName !== '' && PortalComponentConstants.AdaComponentIgnoreList.indexOf(linkName) === -1) {
                    element.insertAdjacentHTML('beforebegin', '<a name="nxi-f2-component-' + linkName + '"href="#" style="visibility: hidden;position:absolute">.</a>');
                    element.insertAdjacentHTML('afterend', '<p class="back-to-contents icon-arrow-up"><a href="' + url + '#table-of-contents">' + this.backToPage + '</a></p>');
                    document.querySelector('[page-link]').insertAdjacentHTML('beforeend',
                        '<li class="icon-arrow-down fw-PageContents_Link"><a href=' + url + '#nxi-f2-component-' + linkName + '>'
                        + this.translationService.translate.instant(linkName) + '</a></li>');
                }
            } else if (linkName === 'content-management' && element && element.getAttribute('ng-reflect-article-id')) {
                let isEntitledforView = true;
                let entitlementValue = element.getAttribute('ng-reflect-entitlement');
                if (entitlementValue) {
                    isEntitledforView = this.authService.isEntitled(entitlementValue);
                }
                if (isEntitledforView) {
                    linkName = element.getAttribute('ng-reflect-article-id');
                    if (PortalComponentConstants.propertyMap.get(this.ibdConfigMap.IBD) && PortalComponentConstants.propertyMap.get(this.ibdConfigMap.IBD).get(linkName)) {
                        linkName = PortalComponentConstants.propertyMap.get(this.ibdConfigMap.IBD).get(linkName);
                    }
                    element.insertAdjacentHTML('beforebegin', '<a name="content-management-' + linkName + '"href="#" style="visibility: hidden;position:absolute">.</a>');
                    element.insertAdjacentHTML('afterend', '<p class="back-to-contents icon-arrow-up"><a href="' + url + '#table-of-contents">' + this.backToPage + '</a></p>');
                    document.querySelector('[page-link]').insertAdjacentHTML('beforeend',
                        '<li class="icon-arrow-down fw-PageContents_Link"><a href=' + url + '#content-management-' + linkName
                        + '>' + this.translationService.translate.instant(linkName) + '</a></li>');
                }
            } else if (linkName === 'cms-text' && element && element.getAttribute('ng-reflect-content-name')) {
                linkName = element.getAttribute('ng-reflect-content-name');
                element.insertAdjacentHTML('beforebegin', '<a name="cms-text-' + linkName + '"href="#" style="visibility: hidden;position:absolute">.</a>');
                element.insertAdjacentHTML('afterend', '<p class="back-to-contents icon-arrow-up"><a href="' + url + '#table-of-contents">' + this.backToPage + '</a></p>');
                let cmsTitle = element.querySelector('.cms-title').innerText;
                if ( !cmsTitle ) {
                    cmsTitle = this.translationService.translate.instant(linkName.toLowerCase());
                }
                document.querySelector('[page-link]').insertAdjacentHTML('beforeend',
                    '<li class="icon-arrow-down fw-PageContents_Link"><a name="cms-text-link-' + linkName +'" href="' + url + '#cms-text-' + linkName
                    + '">' + cmsTitle + '</a></li>');
            } else if (PortalComponentConstants.MultiPageContentLinksList.indexOf(linkName) !== -1) {
                const pageContentLinks: any[] = PortalComponentConstants.AdaPageContentLinks[linkName];
                if (pageContentLinks && pageContentLinks.length > 0) {
                    for (let linkCount = 0; linkCount < pageContentLinks.length; linkCount++) {
                        const linkData = pageContentLinks[linkCount];
                        document.querySelector('[page-link]').insertAdjacentHTML('beforeend',
                            '<li class="icon-arrow-down fw-PageContents_Link"><a href=' + url + '#' + linkData.linkId
                            + '>' + this.translationService.translate.instant(linkData.linkName) + '</a></li>');
                    }
                }
            } else if (linkName === 'edocs-wrapper') {
                element.insertAdjacentHTML('beforebegin', '<a name="' + linkName + '"href="#" style="visibility: hidden;position:absolute">.</a>');
                element.insertAdjacentHTML('afterend', '<p class="back-to-contents icon-arrow-up"><a href="' + url + '#table-of-contents">' + this.backToPage + '</a></p>');
                document.querySelector('[page-link]').insertAdjacentHTML('beforeend',
                    '<li class="icon-arrow-down fw-PageContents_Link"><a href=' + url + '#' + linkName
                    + '>' + this.translationService.translate.instant(this.queryParam) + '</a></li>');
            } else if (linkName === 'dojo-financial-plan-overview' && sessionStorage.getItem('rmvFinPlan')) {
                console.log('No Financial plan link');
            } else if (PortalComponentConstants.AdaComponentIgnoreList.indexOf(linkName) === -1) {
                if (element && linkName.toUpperCase() === element.tagName && element.childElementCount > 0) {
                    if (PortalComponentConstants.propertyMap.get(this.ibdConfigMap.IBD) && PortalComponentConstants.propertyMap.get(this.ibdConfigMap.IBD).get(linkName)) {
                        linkName = PortalComponentConstants.propertyMap.get(this.ibdConfigMap.IBD).get(linkName);
                    }
                    element.insertAdjacentHTML('beforebegin', '<a name="' + linkName + '"href="#" style="visibility: hidden;position:absolute">.</a>');
                    element.insertAdjacentHTML('afterend', '<p class="back-to-contents icon-arrow-up"><a href="' + url + '#table-of-contents">' + this.backToPage + '</a></p>');
                    document.querySelector('[page-link]').insertAdjacentHTML('beforeend',
                        '<li class="icon-arrow-down fw-PageContents_Link"><a href=' + url + '#' + linkName
                        + '>' + this.resolveComponentTitle(element, linkName) + '</a></li>');
                }
            }
        });
    }

    resolveComponentTitle(componentNode: any, componentId: string) {
        if (componentNode && !!componentId && componentId === 'balances-summary') {
            // This has dynamic header legend depending on quote selection.
            return !!sessionStorage.getItem('realTimeActive') && sessionStorage.getItem('realTimeActive') === 'true' ?
                this.translationService.translate.instant(componentId) : this.translationService.translate.instant(componentId) + '<sup>†</sup>';
        } else if (componentNode && !!componentId && (componentId === 'registration-signup' || componentId === 'ng-financial-advisor')) {
            if (this.ibdConfigMap.community) {
                let key = componentId + '.' + this.ibdConfigMap.community + '.' + componentId;
                return this.translationService.translate.instant(key) !== key ?
                this.translationService.translate.instant(key) : this.translationService.translate.instant(componentId + '.generic.' + componentId);
            } else {
                return this.translationService.translate.instant(componentId + '.generic.' + componentId);
            }
        } else {
            return this.translationService.translate.instant(componentId);
        }
    }
}
